module.exports = __webpack_public_path__ + "media/images/logo-1573c92b9ce835566b833d7ea56db4bd.png";